module.exports = __webpack_public_path__ + "static/media/bolso (28).9d4bace4.jpg";